"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _stylitas = require("@creditas/stylitas");

var _sizes = require("./sizes");

const builder = (theme, name) => {
  const upperCaseName = name.toUpperCase();
  const family = theme[`font${upperCaseName}Family`];
  const size = theme[`font${upperCaseName}Size`];
  const lineHeight = theme[`font${upperCaseName}LineHeight`];
  const letterSpacing = theme[`font${upperCaseName}Spacing`];
  return `font-family: ${family};
    font-size: ${size};
    line-height: ${lineHeight};
    letter-spacing: ${letterSpacing};`;
};

const styles = _sizes.sizes.reduce((acc, size) => {
  acc[size] = theme => (0, _stylitas.css)`
    ${builder(theme, size)}
  `;

  acc[size.toUpperCase()] = theme => (0, _stylitas.css)`
    ${builder(theme, size)}
  `;

  return acc;
}, {});

exports.styles = styles;